import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=2c472cfb&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=2c472cfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c472cfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c472cfb')) {
      api.createRecord('2c472cfb', component.options)
    } else {
      api.reload('2c472cfb', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=2c472cfb&scoped=true&", function () {
      api.rerender('2c472cfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitoring/Navigation.vue"
export default component.exports